import React from 'react'
import Icon from 'react-icon-base'

const TagIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m34.4 18.7c0.8 0.8 0.8 2.2 0 3l-2.3 2.3c0.9-0.9 0.8-2.2 0-3.1l-14.9-15h-0.1c-0.6-0.5-1.2-0.9-2.1-0.9l-7-0.2h-0.3c-0.7 0-1.5 0.2-2.1 0.7l2.2-2.1c0.6-0.6 1.3-0.9 2.1-0.9h0.3l7.1 0.3c0.8 0 1.4 0.3 2.1 0.9h0.1l0 0.1 14.9 14.9z m-3.5 3.3c0.9 0.9 0.9 2.3 0 3.2l-8.4 8.5v-0.1l-2 2.1-1.2 1.2c-0.8 0.8-2 0.8-2.9 0.1l-0.2-0.3-14.9-15.1c-0.4-0.4-0.8-1.1-0.8-1.7v-0.1l-0.5-6.9v-0.3c0-0.9 0.3-1.7 0.9-2.3l3.6-3.7c0.6-0.4 1.4-0.7 2.1-0.7h0.3l7 0.3c0.9 0 1.5 0.3 2.1 0.8l0.2 0.1 14.7 14.9z m-24.7-11.1c-1 0.7-1.7 1.7-1.7 2.9 0 1.9 1.5 3.4 3.4 3.4 1.2 0 2.3-0.7 2.9-1.7 0.3-0.5 0.5-1 0.5-1.7 0-1.8-1.5-3.4-3.4-3.4-0.6 0-1.2 0.2-1.7 0.5z" />
    </g>
  </Icon>
)

export default TagIcon
